import template from './flow.html';
import controller from './flow.controller';
import './flow.styl';

let flowComponent = {
  restrict: 'E',
  bindings: {},
  template,
  controller,
  controllerAs: 'vm'
};

export default flowComponent;



/** WEBPACK FOOTER **
 ** E:/JUGGLE_STREET/Juggle-Street-Deployment-All/JSBIGFOOTFRONTEND-BACKEND/admin-frontend/client/app/containers/flow/flow.component.js
 **/